import _isNil from 'hs-lodash/isNil';
import _omitBy from 'hs-lodash/omitBy';
import { useMemo, useState } from 'react';
import CrmObjectPreviewModal from '../components/CrmObjectPreviewModal/CrmObjectPreviewModal';
import { defaultCrmObjectPreviewModalContextProps } from '../contexts/previewModal/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const usePreviewModal = props => {
  const definedProps = _omitBy(props, _isNil);
  const [activeObjectId, setActiveObjectId] = useState('');
  const openModal = data => {
    setActiveObjectId(data);
  };
  const closeHandler = () => {
    setActiveObjectId('');
  };
  const componentProps = useMemo(() => Object.assign({}, defaultCrmObjectPreviewModalContextProps, definedProps, {
    activeObjectId,
    onClose: closeHandler
  }), [activeObjectId, definedProps]);
  return [openModal, /*#__PURE__*/_jsx(CrmObjectPreviewModal, Object.assign({}, componentProps), "preview-modal")];
};
export default usePreviewModal;